import {Button, Image} from "../../../../../../../components";
import documentIcon from "../../../../../../../assets/images/svg/document.svg";
import FileSize from "../../../../../../../components/common/utils/FileSize/FileSize";
import {formatDate} from "../../../../../../../formatters";
import React, {useState} from "react";
import styles from '../DocumentsToProjectsItem.module.scss';
import dots from "../../../../../../../assets/images/svg/dots-green.svg";
import {Agreement} from "../../../../../../../api-client/models/documents/Agreement";
import {downloadPDF} from "../../../../../../../utils/downloadPDF";

interface Props {
    document: Agreement
}

export const AgentDocumentAgreement = ({document}: Props) => {
  const [activeDownload, setActiveDownload] = useState(false);

  return (
    <ul key={document.uuid} className={styles.documentsToProjectBody__list}>
      <li className={styles.documentsToProjectBody__item}>
        <Image className={styles.documentsToProjectBody__icon} src={documentIcon}/>
        <a href={document.file.url} target="_blank"
          rel="noreferrer" className={styles.documentsToProjectBody__title}>Подтверждение присоединения к
          агентскому договору
        </a>
        <a href={document.file.url} target="_blank"
          rel="noreferrer" className={styles.documentsToProjectBody__size}>pdf, <FileSize
            file={document.file}/></a>
        <a className={styles.documentsToProjectBody__watch}
          href={document.file.url} target="_blank"
          rel="noreferrer">Нажмите, чтобы посмотреть</a>
        <a href={document.file.url} target="_blank"
          rel="noreferrer"
          className={styles.documentsToProjectBody__date}>{formatDate(document.createdAt)}</a>
        <a href={document.file.url} target="_blank"
          rel="noreferrer" className={styles.documentsToProjectBody__dateText}>дата подписания</a>
        <div className={styles.documentsToProjectBody__makeReport}>
          <Button className={styles.documentsToProjectBody__buttonSave}
            onClick={() => setActiveDownload((prevState) => !prevState)}>
            <div/>
            скачать <Image className={styles.documentsToProjectItemTitle__arrowButton__image__download}
              src={dots}/>
          </Button>

          {activeDownload && <div className={styles.documentsToProjectBody__download}>
            <Button
              className={styles.documentsToProjectBody__buttonDownload}
              onClick={() => downloadPDF(`${document.file.url}`, document.file.name)}>
              <div/>
              скачать PDF
            </Button>
          </div>}
        </div>

      </li>
    </ul>
  );
};